import React, { useState, useRef } from 'react';
import { FaChevronRight } from 'react-icons/fa';

const CategoryDropdown = ({ categories, handleCategoryClick, onClose }) => {
  const [clickedCategoryId, setClickedCategoryId] = useState({});
  const [subcategoriesData, setSubcategoriesData] = useState({});
  const [loadingStates, setLoadingStates] = useState({});
  const dropdownRef = useRef(null);
  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

  const getCategoryImage = (category) => {
    const categoryName = category.acMainCategory || category.name;
    const images = {
      'Display, Televizori, Projektori, Audio': 'https://resource.ewe.rs/media/category/2022/07/Televizori-projektori-audio.png',
      'Klima uređaji i grejna tela': 'https://resource.ewe.rs/media/category/2022/07/Klima-uredjaji-i-grejna-tela.png',
      'Kućni aparati i posuđe': 'https://resource.ewe.rs/media/category/2022/07/Kucni-kuhinjski-aparati-i-posudje.png',
      'Mobilni telefoni i oprema': 'https://resource.ewe.rs/media/category/2020/07/Mobilni telefoni i oprema.png',
      'Štampači, skeneri i potrošni': 'https://resource.ewe.rs/products/PRI05551_v.jpg',
      'Mobilni telefoni, tableti i oprema': '/telefoni.png',
      'Fitnes, putovanje i zabava': '/fitnes.png',
      'Outlet': 'https://cdn-icons-png.flaticon.com/512/1057/1057323.png'
    };

    if (images[categoryName]) return images[categoryName];

    const sanitizedName = categoryName
      .normalize('NFD').replace(/[\u0300-\u036f]/g, '')
      .replace(/[^a-zA-Z0-9]+/g, '-')
      .replace(/(^-+|-+$)/g, '');

    return `https://resource.ewe.rs/media/category/2022/07/${sanitizedName}.png`;
  };

  const fetchSubcategories = async (categoryId) => {
    setLoadingStates(prev => ({ ...prev, [categoryId]: true }));
    try {
      const response = await fetch(
        `${API_BASE_URL}/ewe/products/categories/${categoryId}`
      );
      if (!response.ok) throw new Error('Failed to fetch subcategories');
      const data = await response.json();
      setSubcategoriesData(prev => ({ ...prev, [categoryId]: data }));
    } catch (error) {
      console.error(`Error fetching subcategories for ${categoryId}:`, error);
    } finally {
      setLoadingStates(prev => ({ ...prev, [categoryId]: false }));
    }
  };

  const toggleCategory = async (categoryId, e) => {
    e?.stopPropagation();
    if (!subcategoriesData[categoryId]) await fetchSubcategories(categoryId);
    setClickedCategoryId(prev => ({ ...prev, [categoryId]: !prev[categoryId] }));
  };

  const getCategoryChildren = (category) => {
    return subcategoriesData[category.id] || category.children || [];
  };

  const buildCategoryStructure = (categories) => {
    const map = {};
    const roots = [];
    categories.forEach(category => map[category.id] = { ...category, children: [] });
    categories.forEach(category => {
      category.parentId
        ? map[category.parentId]?.children.push(map[category.id])
        : roots.push(map[category.id]);
    });
    return roots;
  };

  const displayCategories = categories[0]?.anMainCategoryKey
    ? buildCategoryStructure(categories)
    : categories;

  return (
    <div className="dropdown-content" ref={dropdownRef} onClick={e => e.stopPropagation()}>
      {displayCategories.map((category) => {
        const children = getCategoryChildren(category);
        const hasChildren = children.length > 0;
        const categoryImage = getCategoryImage(category);

        return (
          <div key={category.id} className="category-item-container">
            <div className="category-item">
              <span className="category-image-box">
                <img
                  src={categoryImage}
                  alt=""
                  className="category-image"
                  onError={(e) => e.target.style.visibility = 'hidden'}
                />
              </span>

              <span
                className="category-name"
                onClick={(e) => {
                  e.stopPropagation();
                  handleCategoryClick(category);
                  onClose?.();
                }}
              >
                {category.name}
              </span>

              {hasChildren && (
                <span
                  className={`toggle-icon ${clickedCategoryId[category.id] ? 'expanded' : ''}`}
                  onClick={(e) => toggleCategory(category.id, e)}
                >
                  <FaChevronRight />
                </span>
              )}
            </div>

            {hasChildren && (
              <div className={`submenu ${clickedCategoryId[category.id] ? 'visible' : ''}`}>
                <CategoryDropdown
                  categories={children}
                  handleCategoryClick={handleCategoryClick}
                  onClose={onClose}
                />
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
};

export default CategoryDropdown;